module.exports = __webpack_public_path__ + "img/thumb-icon.db038b21.svg";